window.togglePassword = (field) => {
    const el = document.getElementById(field);
    if (el !== null) {
        el.type = el.type === "password" ? "text" : "password";
    }
};


// WEBPACK FOOTER //
// ./Scripts/togglepassword.js